import {defineAnimatedKeyNumbers} from 'app/components/animatedKeyNumbers/defineAnimatedKeyNumbers';
import {defineBranchDetailPageRedirection} from 'app/components/branchDetailPageRedirection/defineBranchDetailPageRedirection';
import {defineBranchSearch} from 'app/components/branchSearch/defineBranchSearch';
import {defineComparisonTable} from 'app/components/comparisonTable/defineComparisonTable';
import {defineEamHeroMap} from 'app/components/eamHeroMap/defineEamHeroMap';
import {defineInfoHeader} from 'app/components/infoHeader/defineInfoHeader';
import {defineKeyInformation} from 'app/components/keyInformation/defineKeyInformation';
import {defineLeftNavigation} from 'app/components/leftNavigation/defineLeftNavigation';
import {defineMultimediaCollage} from 'app/components/multimedia/gallery/collage/defineMultimediaCollage';
import {defineMultimediaGrid} from 'app/components/multimedia/gallery/grid/defineMultimediaGrid';
import {defineMultimediaPinterest} from 'app/components/multimedia/gallery/pinterest/defineMultimediaPinterest';
import {defineMultimediaSlider} from 'app/components/multimedia/gallery/slider/defineMultimediaSlider';
import {defineMultimediaImage} from 'app/components/multimedia/image/defineMultimediaImage';
import {defineMultimediaVideo} from 'app/components/multimedia/video/defineMultimediaVideo';
import {definePaymentFileValidation} from 'app/components/paymentFileValidation/definePaymentFileValidation';
import {defineQrCode} from 'app/components/qrCode/defineQrCode';
import {defineSalesCards} from 'app/components/salesCards/defineSalesCards';
import {defineTextWithImage} from 'app/components/textWithImageSSR/defineTextWithImage';
import {defineTextWithVideo} from 'app/components/textWithVideo/defineTextWithVideo';
import {defineAuthorComponentAlert} from 'app/modules/authorComponentAlert/defineAuthorComponentAlert';
import {defineCssLoader} from 'app/modules/cssLoader/defineCssLoader';
import {defineEditorContent} from 'app/modules/editorContent/defineEditorContent';
import {defineRteImg} from 'app/modules/editorContent/rteImg/defineRteImg';
import {defineRteLink} from 'app/modules/editorContent/rteLink/defineRteLink';
import {defineRteReadMore} from 'app/modules/editorContent/rteReadMore/defineRteReadMore';
import {defineRteTooltip} from 'app/modules/editorContent/rteTooltip/defineRteTooltip';
import {defineInjectSVG} from 'app/modules/injectSVG/defineInjectSVG';
import {defineInlineCountdown} from 'app/modules/inlineCountdown/defineInlineCountdown';
import {defineTermTooltip} from 'app/modules/termTooltip/defineTermTooltip';
import {GemSettings} from 'app/utils/config/interface';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineWebComponents(gemSettings: GemSettings, lazyLoadPage?: boolean) {
    const WebComponentLoader = getWebComponentLoader(gemSettings, lazyLoadPage);

    defineAnimatedKeyNumbers(WebComponentLoader);
    defineQrCode(WebComponentLoader);
    defineMultimediaImage(WebComponentLoader);
    defineMultimediaVideo(WebComponentLoader);
    defineMultimediaGrid(WebComponentLoader);
    defineMultimediaSlider(WebComponentLoader);
    defineMultimediaPinterest(WebComponentLoader);
    defineMultimediaCollage(WebComponentLoader);
    definePaymentFileValidation(WebComponentLoader);
    defineEditorContent(WebComponentLoader);
    defineRteLink(WebComponentLoader);
    defineRteImg(WebComponentLoader);
    defineRteReadMore(WebComponentLoader);
    defineRteTooltip(WebComponentLoader);
    defineTermTooltip(WebComponentLoader);
    defineInlineCountdown(WebComponentLoader);
    defineLeftNavigation(WebComponentLoader);
    defineInjectSVG(WebComponentLoader);
    defineComparisonTable(WebComponentLoader);
    defineSalesCards(WebComponentLoader);
    defineTextWithImage(WebComponentLoader);
    defineKeyInformation(WebComponentLoader);
    defineBranchSearch(WebComponentLoader);
    defineBranchDetailPageRedirection(WebComponentLoader);
    defineInfoHeader(WebComponentLoader);
    defineAuthorComponentAlert();
    defineEamHeroMap(WebComponentLoader);
    defineTextWithVideo(WebComponentLoader);
    defineCssLoader();
}
